import AmpleHireImageTag from "../ample-hire-html-tags/ample-hire-image-tag";
import { useGlobalContext } from "../../context";

const InterviewHeader = () => {
	const { interviewJobName, rootColor } = useGlobalContext();
	return (
		<header className="int-header">
			<aside className="col xl8 l8 m8 s8" style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "10px" }}>
				<div className="int-logo-brand">
					<AmpleHireImageTag imgSrc={rootColor.logoUrl} altText="brand logo image" />
				</div>
				{interviewJobName && <h2 style={{ fontSize: "18px", fontWeight: "700", margin: "0", color: "var(--text-primary)", letterSpacing: "-0.3px" }}>{interviewJobName}</h2>}
			</aside>
		</header>
	)
}

export default InterviewHeader;
